/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ServiceTypeEnum } from './serviceTypeEnum';


export interface DeploymentDeletionSpec { 
    /**
     * Org id
     */
    org_id: string;
    type: ServiceTypeEnum;
    /**
     * Approve deletion (applicable if Deployment is in Approval pending state)
     */
    approve_deletion?: boolean;
    /**
     * Force delete Deployment object from DB (STG only)
     */
    force_delete?: boolean;
    /**
     * Skip deleting shadow account resources during deactivation.
     */
    skip_resource_deletion?: boolean;
}
export namespace DeploymentDeletionSpec {
}


